const getProductToken = (slug: string, ean: string) => `${slug}--${ean}`;

export default getProductToken;
